import React, { useState } from 'react';
import All from './All';
import HTML from './HTML';
import JavaScript from './JavaScript';
import './Projects.css';
import ReactJS from './ReactJS';

const Projects = () => {
    const [topBar, setTopBar] = useState(0);

    const topNavBarAll = (
        <div className="topnav">
            <span onClick={() => setTopBar(0)} className="active">All</span>
            <span onClick={() => setTopBar(1)}>ReactJS</span>
            <span onClick={() => setTopBar(2)}>JavaScript</span>
            <span onClick={() => setTopBar(3)}>HTML/CSS</span>
        </div>
    )

    const topNavBarReact= (
        <div className="topnav">
            <span onClick={() => setTopBar(0)}>All</span>
            <span onClick={() => setTopBar(1)} className="active">ReactJS</span>
            <span onClick={() => setTopBar(2)}>JavaScript</span>
            <span onClick={() => setTopBar(3)}>HTML/CSS</span>
        </div>
    )

    const topNavBarJS= (
        <div className="topnav">
            <span onClick={() => setTopBar(0)}>All</span>
            <span onClick={() => setTopBar(1)}>ReactJS</span>
            <span onClick={() => setTopBar(2)} className="active">JavaScript</span>
            <span onClick={() => setTopBar(3)}>HTML/CSS</span>
        </div>
    )

    const topNavBarHTML= (
        <div className="topnav">
            <span onClick={() => setTopBar(0)}>All</span>
            <span onClick={() => setTopBar(1)}>ReactJS</span>
            <span onClick={() => setTopBar(2)}>JavaScript</span>
            <span onClick={() => setTopBar(3)} className="active">HTML/CSS</span>
        </div>
    )

    return (
        <section>
            {
                topBar === 0 ? topNavBarAll :
                topBar === 1 ? topNavBarReact :
                topBar === 2 ? topNavBarJS :
                topNavBarHTML
            }
            <div className="App container-about center">
                <div className="container">
                    <section>
                        {
                            topBar === 0 ? <All /> : topBar === 1 ? <ReactJS /> : topBar === 2 ? <JavaScript /> : <HTML />
                        }
                    </section>
                </div>
            </div>
        </section>
    );
};

export default Projects;